<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div v-show="!processDisabled" class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 단위공정 -->
          <c-process
            :editable="editable"
            :disabled="processDisabled"
            label="LBL0001701"
            name="subProcessCd"
            v-model="searchParam.subProcessCd">
          </c-process>
        </div>
      </template>
    </c-search-box>
    <!-- 작업/작업단계/유해위험요인 목록 -->
    <c-table
      ref="table"
      title="LBL0001708"
      :merge="popupParam.searchType=='1' ? grid1.merge : popupParam.searchType=='2' ? grid2.merge : popupParam.searchType=='3' ? grid3.merge : popupParam.searchType=='4' ? grid4.merge : popupParam.searchType=='5' ? grid5.merge : popupParam.searchType=='6' ? grid6.merge : grid7.merge"
      :columns="popupParam.searchType=='1' ? grid1.columns : popupParam.searchType=='2' ? grid2.columns : popupParam.searchType=='3' ? grid3.columns : popupParam.searchType=='4' ? grid4.columns : popupParam.searchType=='5' ? grid5.columns : popupParam.searchType=='6' ? grid6.columns : grid7.columns"
      :data="popupParam.searchType=='1' ? grid1.data : popupParam.searchType=='2' ? grid2.data : popupParam.searchType=='3' ? grid3.data : popupParam.searchType=='4' ? grid4.data : popupParam.searchType=='5' ? grid5.data : popupParam.searchType=='6' ? grid6.data : grid7.data"
      :gridHeight="grid1.height"
      :selection="popupParam.type"
      :isExcelDown="false"
      :isExpan="false"
      :isFullScreen="false"
      :columnSetting="false"
      rowKey="idx"
      @linkClick="openPop"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'sop-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          // 1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 
          // 4:작업단계별 유해위험요인별 원인/결과, 5. 공정별 유해위험요인, 
          // 6. 단위공정별 유해위험요인 원인 / 결과
          // 7. 단위공정별 작업별 유해위험요인
          searchType: '1', 
          subProcessCd: '',
          jobStepId: '',
          mdmHazardFactorsId: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      searchParam: {
        plantCd: null,
        subProcessCd: '',
        sopName: '',
        jobStepName: '',
        useFlag: 'Y',
        jobStepId: '',
        mdmHazardFactorsId: '',
      },
      grid1: {
        merge: [],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            // 작업명
            label: 'LBL0000223',
            align: 'left',
            sortable: false,
          },
          {
            name: 'sopNo',
            field: 'sopNo',
            // 작업표준번호
            label: 'LBL0001707',
            align: 'center',
            type: 'link',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      grid2: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            // 작업명
            label: 'LBL0000223',
            align: 'left',
            type: 'link',
            sortable: false,
          },
          {
            name: 'jobStepName',
            field: 'jobStepName',
            // 작업단계
            label: 'LBL0001103',
            align: 'left',
            sortable: false,
          },
          {
            name: 'jobStepDesc',
            field: 'jobStepDesc',
            // 작업방법(상세설명)
            label: 'LBL0001706',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      grid3: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
          { index: 2, colName: 'jobStepName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            // 작업명
            label: 'LBL0000223',
            align: 'left',
            sortable: false,
            type: 'link',
          },
          {
            name: 'jobStepName',
            field: 'jobStepName',
            // 작업단계
            label: 'LBL0001103',
            align: 'left',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            // 유해위험요인
            label: 'LBL0001050',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      grid4: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
          { index: 2, colName: 'jobStepName' },
          { index: 3, colName: 'riskHazardName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            // 작업명
            label: 'LBL0000223',
            align: 'left',
            type: 'link',
            sortable: false,
          },
          {
            name: 'jobStepName',
            field: 'jobStepName',
            // 작업단계
            label: 'LBL0001103',
            align: 'left',
            sortable: false,
          },
          {
            name: 'ramRiskHazardClassName',
            field: 'ramRiskHazardClassName',
            // 유해위험요인 분류
            label: 'LBL0001155',
            align: 'center',
            style: 'width: 150px',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            // 유해위험요인
            label: 'LBL0001050',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurReason',
            field: 'hazardOccurReason',
            // 원인
            label: 'LBL0001006',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurResult',
            field: 'hazardOccurResult',
            // 결과
            label: 'LBL0001007',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      grid5: {
        merge: [
          { index: 0, colName: 'processName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'ramRiskHazardClassName',
            field: 'ramRiskHazardClassName',
            // 유해위험요인 분류
            label: 'LBL0001155',
            align: 'center',
            style: 'width: 150px',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            // 유해위험요인
            label: 'LBL0001050',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      grid6: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'riskHazardName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            // 유해위험요인
            label: 'LBL0001050',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurReason',
            field: 'hazardOccurReason',
            // 원인
            label: 'LBL0001006',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurResult',
            field: 'hazardOccurResult',
            // 결과
            label: 'LBL0001007',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      grid7: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            // 공정명
            label: 'LBLPROCESS',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            // 작업명
            label: 'LBL0000223',
            align: 'left',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            // 유해위험요인
            label: 'LBL0001050',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    processDisabled() {
      return this.popupParam.subProcessCd ? this.popupParam.subProcessCd.indexOf('WTE') === -1 : false;
    }
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid1.height = height + 'px'
    },
  },
  methods: {
    init() {
      switch(this.popupParam.searchType) {
        case '1':
          this.listUrl = selectConfig.mdm.sop.job.list.url;
          break;
        case '2':
          this.listUrl = selectConfig.mdm.sop.jobstep.url;
          break;
        case '3':
          this.listUrl = selectConfig.mdm.sop.jobhazard.url;
          break;
        case '4':
          this.listUrl = selectConfig.mdm.sop.jobhazardreason.url;
          break;
        case '5':
          this.listUrl = selectConfig.mdm.sop.processHazard.url;
          break;
        case '6':
          this.listUrl = selectConfig.mdm.sop.processHazardReason.url;
          break;
        case '7':
          this.listUrl = selectConfig.mdm.sop.sopHazard.url;
          break;
      }

      if (this.popupParam.subProcessCd) {
        if (this.popupParam.subProcessCd.indexOf('WTE') === -1) {
          this.searchParam.subProcessCd = this.popupParam.subProcessCd
        } else {
          this.searchParam.subProcessCd = null;
        }
      }
      if (this.popupParam.jobStepId) {
        this.searchParam.jobStepId = this.popupParam.jobStepId
      }
      if (this.popupParam.mdmHazardFactorsId) {
        this.searchParam.mdmHazardFactorsId = this.popupParam.mdmHazardFactorsId
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        switch(this.popupParam.searchType) {
          case '1':
            this.grid1.data = _result.data;
            break;
          case '2':
            this.grid2.data = _result.data;
            break;
          case '3':
            this.grid3.data = _result.data;
            break;
          case '4':
            this.grid4.data = _result.data;
            break;
          case '5':
            this.grid5.data = _result.data;
            break;
          case '6':
            this.grid6.data = _result.data;
            break;
          case '7':
            this.grid7.data = _result.data;
            break;
        }
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다. 
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    openPop(row) {
      this.popupOptions.title = 'LBL0001093'; // 안전작업표준 상세
      this.popupOptions.param = {
        mdmSopId: row ? row.mdmSopId : '',
        tabpage: 'sopReport'
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/pim/sopDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '80%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
